module.exports = __webpack_public_path__ + "static/media/NICE_Step0_Title_card.9713e52f.jpg";